<template>
  <div class="spm-data-container" v-if="$store.state.spmDashboardFrom">
    <div class="spm-chart">
      <div
        class="d-flex justify-content-center align-items-center chartContainer"
      >
       <highcharts :options="chartOptions"></highcharts>
      </div>
    </div>
    <div class="spm-table">
      <b-table
        striped
        bordered
        no-border-collapse
        responsive
        :items="checkSpmData"
        :fields="fields"
        foot-clone
      >
      <template v-slot:foot(total)>
        <div>
          <span>{{ totalAll(items)}}</span>
        </div>
      </template>
      <template v-slot:foot(sangat_memuaskan)>
        <div>
          <span>{{ totalFootCategory('sangat_memuaskan') }}</span>
        </div>
      </template>
      <template v-slot:foot(memuaskan)>
        <div>
          <span>{{ totalFootCategory('memuaskan') }}</span>
        </div>
      </template>
      <template v-slot:foot(cukup_memuaskan)>
        <div>
          <span>{{ totalFootCategory('cukup_memuaskan') }}</span>
        </div>
      </template>
      <template v-slot:foot(tidak_memuaskan)>
        <div>
          <span>{{ totalFootCategory('tidak_memuaskan') }}</span>
        </div>
      </template>
      <template v-slot:foot(sangat_buruk)>
        <div>
          <span>{{ totalFootCategory('sangat_buruk') }}</span>
        </div>
      </template>
      <template v-slot:foot(company)>
        <div>
          <span>Total</span>
        </div>
      </template>

      </b-table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {api} from '../../services/config'
import {companyData, categoryChart} from '../../store/company'
Highcharts.setOptions({
    colors: ['#fff', '#ff4c4c', '#d34c4c','#10253f', '#a0b376', '#ffd34c']
});
export default {
  name : 'SpmCompany',
  data: function() {
    return {
      fields:[
        { key : "company", label : "Company", thClass : 'bg-head' },
        { key : "sangat_buruk", label : 'Sangat Buruk', thClass : 'bg-head'},
        { key : "tidak_memuaskan", label : "Tidak Memuaskan" , thClass : 'bg-head'},
        { key : "cukup_memuaskan", label : "Cukup Memuaskan" , thClass : 'bg-head'},
        { key : "memuaskan", label : "Memuaskan" , thClass : 'bg-head'},
        { key : "sangat_memuaskan", label : "Sangat Memuaskan" , thClass : 'bg-head'},
        { key : "total", label : "Total", thClass : 'bg-head'}
      ],
      // items : [
      //   { company : "BCE", sangat_buruk : 10,tidak_memuaskan : 2,cukup_memuaskan : 5, memuaskan : 87, sangat_memuaskan : 4, total : 108},
      //   { company : "GEMS", sangat_buruk : 5, tidak_memuaskan : 0,cukup_memuaskan : 60, memuaskan : 90, sangat_memuaskan : 5, total : 160},
      //   { company : "MTL",sangat_buruk : 15, tidak_memuaskan : 80,cukup_memuaskan : 5, memuaskan : 10, sangat_memuaskan : 0, total : 110},
      // ],
      items : null,
      sunburstData : null,
      chartOptions: {
        chart: {
          height: '300',
        },
        title: {
          text: "SPM Company"
        },
        series: [
          {
            type: "sunburst",
            data : [],
            allowDrillToNode: true,
            cursor: "pointer",
            dataLabels: {
              format: "{point.name}",
              filter: {
                property: "innerArcLength",
                operator: ">",
                value: 16
              }
            },
            levels: [
              {
                level: 1,
                levelIsConstant: false,
                dataLabels: {
                  filter: {
                    property: "outerArcLength",
                    operator: ">",
                    value: 64
                  }
                }
              },
              {
                level: 2,
                colorByPoint: true
              },
              {
                level: 3,
                colorVariation: {
                  key: "brightness",
                  to: -0.2
                }
              }
            ]
          }
        ],
        tooltip: {
          headerFormat: "",
          pointFormat:
            "The Percentage of <b>{point.name}</b> is <b>{point.value}%</b> with total <b>{point.real}</b>"
        }
      },
    };
  },
  computed : {
    checkSpmData : {
      get : function(){
        let global = this.$store.state.spmDashboardCompany
        let spmItems = {};

        global &&
          global.forEach(list => {
            if (spmItems[list.SERVER] === undefined) {
              spmItems[list.SERVER] = {
                company: list.SERVER,
                sangat_buruk: list.GRADE == "SANGAT BURUK" ? list.TOTAL : 0,
                tidak_memuaskan:
                  list.GRADE == "TIDAK MEMUASKAN" ? list.TOTAL : 0,
                cukup_memuaskan:
                  list.GRADE == "CUKUP MEMUASKAN" ? list.TOTAL : 0,
                memuaskan: list.GRADE == "MEMUASKAN" ? list.TOTAL : 0,
                sangat_memuaskan:
                  list.GRADE == "SANGAT MEMUASKAN" ? list.TOTAL : 0,
                total: this.totalSpmGlobal(global, list.SERVER)
              };
            } else {
              spmItems[list.SERVER] = {
                company: list.SERVER,
                sangat_buruk:
                  list.GRADE == "SANGAT BURUK"
                    ? (spmItems[list.SERVER]["sangat_buruk"] += list.TOTAL)
                    : spmItems[list.SERVER]["sangat_buruk"],
                tidak_memuaskan:
                  list.GRADE == "TIDAK MEMUASKAN"
                    ? (spmItems[list.SERVER]["tidak_memuaskan"] += list.TOTAL)
                    : spmItems[list.SERVER]["tidak_memuaskan"],
                cukup_memuaskan:
                  list.GRADE == "CUKUP MEMUASKAN"
                    ? (spmItems[list.SERVER]["cukup_memuaskan"] += list.TOTAL)
                    : spmItems[list.SERVER]["cukup_memuaskan"],
                memuaskan:
                  list.GRADE == "MEMUASKAN"
                    ? (spmItems[list.SERVER]["memuaskan"] += list.TOTAL)
                    : spmItems[list.SERVER]["memuaskan"],
                sangat_memuaskan:
                  list.GRADE == "SANGAT MEMUASKAN"
                    ? (spmItems[list.SERVER]["sangat_memuaskan"] +=
                        list.TOTAL)
                    : spmItems[list.SERVER]["sangat_memuaskan"],
                total: this.totalSpmGlobal(global, list.SERVER)
              };
            }
          });

        this.items = Object.values(spmItems)
        this.seriesData()
        return Object.values(spmItems)
      }
    }
  },
  methods: {
    totalSpmGlobal(value, server) {
      let count = 0;
      value &&
        value.map(list => {
          if (list.SERVER == server) {
            count += list.TOTAL;
          }
        });
      return count;
    },
    totalFootCategory(value){
      let data = this.items
      let count = 0
      data && data.map(list => {
        count += list[value]
      })
      return count
    },
    totalAll(value){
      let count = 0
      value && value.map(list => {
        count += list.total
      })
      return count
    },
    totalCategory(value){
      const self = this
      const data = self.items
      if(value){
        let count = 0
        data && data.map(list => {
          count += list[value]
        })
        return count
      }
    },
    seriesData() {
     const self = this
     const data = self.items
     const allCompany = [{ id : '0', parent : '', name : 'SMM', value : 100, real : self.totalAll(data)}]
     let parentCompany = []
     let childCategory = []

     parentCompany.push({
        id : 'sangat_buruk',
        parent : '0',
        name : 'Sangat Buruk',
        value : Math.round((self.totalCategory('sangat_buruk')/self.totalAll(data))*100),
        real : self.totalCategory('sangat_buruk')
      },{
        id : 'tidak_memuaskan',
        parent : '0',
        name : 'Tidak Memuaskan',
        value : Math.round((self.totalCategory('tidak_memuaskan')/self.totalAll(data))*100),
        real : self.totalCategory('tidak_memuaskan')
      },{
        id : 'cukup_memuaskan',
        parent : '0',
        name : 'Cukup Memuaskan',
        value : Math.round((self.totalCategory('cukup_memuaskan')/self.totalAll(data))*100),
        real : self.totalCategory('cukup_memuaskan')
      },{
        id : 'memuaskan',
        parent : '0',
        name : 'Memuaskan',
        value : Math.round((self.totalCategory('memuaskan')/self.totalAll(data))*100),
        real : self.totalCategory('memuaskan')
      },{
        id : 'sangat_memuaskan',
        parent : '0',
        name : 'Sangat Memuaskan',
        value : Math.round((self.totalCategory('sangat_memuaskan')/self.totalAll(data))*100),
        real : self.totalCategory('sangat_memuaskan')
      })

     data && data.map(list => {
       const chartName = Object.entries(list)
       childCategory.push({
         id : `${list.company}_sangat_buruk`,
         parent : 'sangat_buruk',
         name : `${list.company}`,
         value : Math.round((list[chartName[1][0]]/self.totalCategory('sangat_buruk'))*100),
         real : list[chartName[1][0]]
       },{
         id : `${list.company}_tidak_memuaskan`,
         parent : 'tidak_memuaskan',
         name : `${list.company}`,
         value : Math.round((list[chartName[2][0]]/self.totalCategory('tidak_memuaskan'))*100),
         real : list[chartName[2][0]]
       },{
         id : `${list.company}_cukup_memuaskan`,
         parent : 'cukup_memuaskan',
         name :  `${list.company}`,
         value : Math.round((list[chartName[3][0]]/self.totalCategory('cukup_memuaskan'))*100),
         real : list[chartName[3][0]]
       },{
         id : `${list.company}_memuaskan`,
         parent : 'memuaskan',
         name :  `${list.company}`,
         value : Math.round((list[chartName[4][0]]/self.totalCategory('memuaskan'))*100),
         real : list[chartName[4][0]]
       },{
         id : `${list.company}_sangat_memuaskan`,
         parent : 'sangat_memuaskan',
         name :  `${list.company}`,
         value : Math.round((list[chartName[5][0]]/self.totalCategory('sangat_memuaskan'))*100),
         real : list[chartName[5][0]]
       })
     })

     self.chartOptions.series[0].data = [...allCompany, ...parentCompany, ...childCategory]
    },
  },
};
</script>
<style lang="scss">
  @import "~/assets/scss/components/dashboard.scss";
</style>
